import API_BASE from './apiBase';
import API_CONFIG from './apiConfig';
import Axios from 'axios';

class TestApi {

   /**
    *
    * @param
    * @returns {Promise<unknown>}
    */
   static importFile(formData) {
      return new Promise((resolve, reject) => {
         Axios.post(API_BASE.url + API_CONFIG.appUrls.test.importFile, { ...formData })
            .then(response => {
               console.log(response);
               resolve(response);
            })
            .catch(error => {
               reject(error);
            });
      });
   }

}

export default TestApi;